import { Card } from '@/components/ui'
import type { BreakdownRow } from '../toBreakdownRows'
import { BreakdownListRow } from './BreakdownListRow'

export const BreakdownTable = ({
  title,
  rows,
}: {
  title: string
  rows: BreakdownRow[]
}) => (
  <Card className="overflow-hidden">
    <div className="flex items-center justify-between gap-4 px-6 py-4">
      <h4 className="font-semibold">{title}</h4>
      <span className="text-muted-foreground text-xs">
        Showing {rows.length} of {rows.length}
      </span>
    </div>
    {rows.length === 0 ? (
      <p className="text-muted-foreground border-t px-6 py-3 text-sm">
        No usage yet.
      </p>
    ) : (
      <ul>
        {rows.map((row) => (
          <BreakdownListRow key={row.key} row={row} />
        ))}
      </ul>
    )}
  </Card>
)
